import { render, staticRenderFns } from "./CancelRoadsideForm.vue?vue&type=template&id=0b9bdcbe&"
import script from "./CancelRoadsideForm.vue?vue&type=script&lang=js&"
export * from "./CancelRoadsideForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports